module.exports = __webpack_public_path__ + "static/media/FlyerRight.33bce025.png";